import * as ActionGetDoctors from "./Action";

export default {
  ...ActionGetDoctors,
};
